import { render, staticRenderFns } from "./ImportDeal.vue?vue&type=template&id=d5df24b4&"
import script from "./ImportDeal.vue?vue&type=script&lang=js&"
export * from "./ImportDeal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports